import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MedicationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"medication"}/>
}
